import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr.json";
import en from "./en.json";
import ar from "./ar.json";

const stored = (typeof localStorage !== "undefined" && localStorage.getItem("fad.lang")) || "fr";

void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: stored,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
